module.exports = __webpack_public_path__ + "static/media/pic14.9f55bb3f.jpg";